<template>
    <div class="auth-venue-register-container">
        <p class="title">Confirm your info</p>
        <div class="confirmation-wrapper">
            <div v-for="(val, key, indx) in secondFormValues" :key="indx" :class="val.wrapper">
                <p class="label">
                    {{ val.label }}
                </p>
                <div class="data-display">
                    <p v-if="!val.edit && key !== 'venue_type'" class="data">
                        {{ val.value }}
                    </p>
                    <p v-else-if="!val.edit && key === 'venue_type' && val.value" class="data">
                        {{ venueTypes.find((type) => type.selected).name }}
                    </p>
                    <button
                        v-if="!val.edit"
                        @click="editVenueInfo($event, { key, val })"
                        class="edit-btn"
                    >
                        Edit
                    </button>
                    <input
                        v-if="
                            val.edit &&
                            !val.validate &&
                            key !== 'venue_type' &&
                            key !== 'address'
                        "
                        v-model="val.value"
                        v-autofocus
                        @keydown.enter="handleSecondFormEdit(key, val)"
                        @blur="handleSecondFormEdit(key, val)"
                        class="edit-field"
                        type="text"
                    />
                    <input
                        v-else-if="
                            val.edit &&
                            val.validate &&
                            key !== 'venue_type' &&
                            key !== 'address'
                        "
                        v-model="$v.secondFormValues[key].value.$model"
                        v-autofocus
                        :class="{
                            'error-input':
                                $v.secondFormValues[key].value.$dirty &&
                                !$v.secondFormValues[key].value.required
                        }"
                        @blur="closeEdit(key, val)"
                        @keydown.enter="handleSecondFormEdit(key, val)"
                        class="edit-field"
                        type="text"
                    />
                    <input
                        ref="autocomplete"
                        v-else-if="val.edit && val.validate && key === 'address'"
                        v-model="$v.secondFormValues[key].value.$model"
                        v-autofocus
                        :class="{
                            'error-input':
                                $v.secondFormValues[key].value.$dirty &&
                                !$v.secondFormValues[key].value.required
                        }"
                        @blur="closeEdit(key, val)"
                        @keydown.enter="handleSecondFormEdit(key, val)"
                        class="edit-field"
                        type="text"
                    />
                    <div
                        ref="dropdown"
                        v-else-if="dropdownOpen && key === 'venue_type'"
                        class="type-options"
                        @blur="($event) => closeDropdown($event, val)"
                        v-autofocus
                        tabindex="0"
                    >
                        <p
                            v-for="type in venueTypes"
                            :key="type.name"
                            @click="handleSelectType(type, val)"
                            @keyup.enter="handleSelectType(type, val)"
                            class="type-option"
                            tabindex="0"
                        >
                            {{ type.name }}
                        </p>
                    </div>
                </div>
            </div>
            <div v-if="!hideSocialLinks" class="social-link-wrapper">
                <auth-link-social role="venue">
                    <template #message>
                        <p class="label">Social Media</p>
                    </template>
                </auth-link-social>
            </div>
        </div>
        <button @click="handleSecondFormContinue($v)" class="confirm-btn">Confirm</button>
        <button @click="handleSecondFormBack" class="back-btn">Back</button>
    </div>
</template>
<script>
    import { useVenueRegister } from '@/composables/auth/useVenueRegister'
    import AuthLinkSocial from '@/components/auth/parts/AuthLinkSocial.vue'
    import { required } from 'vuelidate/lib/validators'
    export default {
        name: 'AuthVenueRegisterSecondStep',
        components: { AuthLinkSocial },
        validations: {
            secondFormValues: {
                venue_name: {
                    value: { required }
                },
                address: {
                    value: { required }
                }
            }
        },
        setup() {
            const {
                autocomplete,
                hideSocialLinks,
                venueTypes,
                dropdown,
                dropdownOpen,
                editVenueInfo,
                handleToggleDropdown,
                handleSelectType,
                secondFormValues,
                handleSecondFormEdit,
                handleSecondFormContinue,
                handleSecondFormBack
            } = useVenueRegister()
            return {
                autocomplete,
                hideSocialLinks,
                secondFormValues,
                venueTypes,
                dropdown,
                dropdownOpen,
                editVenueInfo,
                handleSecondFormEdit,
                handleSelectType,
                handleToggleDropdown,
                handleSecondFormContinue,
                handleSecondFormBack
            }
        },
        methods: {
            closeEdit(key, val) {
                this.$v.secondFormValues[key].value.$touch()
                this.handleSecondFormEdit(key, val)
            },
            closeDropdown(e, val) {
                if (e.relatedTarget === null) {
                    val.edit = false
                    this.dropdownOpen = false
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .auth-venue-register-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 40px;
        width: 100%;

        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }
        .title {
            color: #dedede;
            font-family: Instrument Sans;
            font-size: 38px;
            font-style: normal;
            font-weight: 500;
            line-height: 110%;
            letter-spacing: -0.76px;
            align-self: flex-start;
        }
        .confirmation-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 20px;
            width: 100%;

            .venue-name-wrapper,
            .venue-type-wrapper,
            .venue-address-wrapper,
            .venue-website-wrapper,
            .social-link-wrapper {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
                gap: 4px;
                width: 100%;

                .label {
                    color: #8b8b8b;
                    font-family: Instrument Sans;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 650;
                    line-height: 135%;
                    letter-spacing: 0.12px;
                    align-self: flex-start;
                }
                .data-display {
                    position: relative;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    min-height: 21px;

                    .data {
                        max-width: 300px;
                        color: #dedede;
                        font-family: Instrument Sans;
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 650;
                        line-height: 120%;
                        text-wrap: wrap;
                    }
                    .edit-btn {
                        margin-left: auto;
                        color: #8b8b8b;
                        font-family: Instrument Sans;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 130%;
                        letter-spacing: 0.14px;
                        background: none;
                        text-decoration-line: underline;
                    }
                    .edit-field {
                        padding: 12px 16px 16px 16px;
                        border-radius: 12px;
                        border: 1px solid #8b8b8b;
                        background: #262626;
                        color: #dedede;
                        font-family: Instrument Sans;
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 650;
                        line-height: 120%;
                        width: 100%;
                    }
                    .error-input {
                        border-color: #ed3c0d !important;
                    }
                    .type-options::-webkit-scrollbar {
                        width: 8px;
                    }
                    .type-options::-webkit-scrollbar-track {
                        background-color: none;
                    }
                    .type-options::-webkit-scrollbar-thumb {
                        max-height: 64px;
                        border-radius: 8px;
                        background: #8b8b8b;
                    }
                    .type-options {
                        position: absolute;
                        z-index: 1;
                        top: 0;
                        right: 10%;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start;
                        align-items: flex-start;
                        gap: 16px;
                        max-width: 100%;
                        max-height: 155px;
                        overflow-y: scroll;
                        overflow-x: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        padding: 12px 12px 16px 16px;
                        border-radius: 7px;
                        border: 1px solid #8b8b8b;
                        background: #262626;

                        .type-option {
                            cursor: pointer;
                            color: #646464;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            font-family: Instrument Sans;
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 550;
                            line-height: 125%;
                            width: 100%;
                        }
                    }
                }
            }
        }
        .confirm-btn {
            padding: 11px 30px 12px 30px;
            border-radius: 100px;
            background: #cdeb09;
            color: black;
            font-family: Instrument Sans;
            font-size: 18px;
            font-style: normal;
            font-weight: 550;
            line-height: 120%;
            width: 100%;
        }
        .back-btn {
            color: #8b8b8b;
            text-align: center;
            font-family: Instrument Sans;
            font-size: 16px;
            font-style: normal;
            font-weight: 550;
            line-height: 125%;
            text-decoration-line: underline;
            background: none;
        }
    }
</style>
